// extracted by mini-css-extract-plugin
export default {"whatsappContainer":"style_whatsappContainer__E2pbU","icon":"style_icon__CCRLE"};